<template>
  <!-- Paginate cursor-->
  <div id="paginate__cursor">
    <div class="pb-0 d-flex justify-end px-3 mt-5">
      <div class="text-right mb-1 mt-2">
        {{ showContactsIndex }}

        <!-- Nút prev -->
        <v-btn
          small
          class="pagination-btn-left"
          :disabled="currentPage == 1"
          @click="onPrevPage()"
        >
          <v-icon>mdi-menu-left</v-icon>
        </v-btn>

        <!-- Nút next -->
        <v-btn
          small
          class="pagination-btn-right"
          :disabled="!paging.nextId"
          @click="onNextPage()"
        >
          <v-icon>mdi-menu-right</v-icon>
        </v-btn>
      </div>

      <!-- Ô input -->
      <!-- <div style="width: 35px">
        <v-text-field
          v-model="pendingPage"
          type="number"
          min="1"
          step="1"
          class="pt-0"
          @input="applyPendingPage()"
        >
        </v-text-field>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "VhCrmFrontendPaginateCursor",

  props: {
    currentPage: {
      type: Number,
      default: 0,
      require: true,
    },
    paging: {
      type: Object,
      default: () => ({}),
      require: true,
    },
    listLength: {
      type: Number,
      default: 0,
    },
    limit: {
      type: Number,
      default: 10,
    },
  },

  computed: {
    showContactsIndex() {
      if (this.listLength > 0) {
        const maxIndex = parseInt(this.currentPage) * parseInt(this.limit);
        return `${maxIndex - parseInt(this.limit) + 1} - ${maxIndex}`;
      } else {
        return "0 - 0";
      }
    },
  },

  methods: {
    // Bấm trang trước
    onPrevPage() {
      this.$emit("change-current-page", {
        id: this.paging.previousId,
        currentPage: this.currentPage - 1,
        backward: true,
      });
    },

    // Bấm trang sau
    onNextPage() {
      this.$emit("change-current-page", {
        id: this.paging.nextId,
        currentPage: this.currentPage + 1,
        backward: false,
      });
    },
  },
};
</script>
